import React from "react";
import "./App.css";
import "./index.css";
import "./components/common_components/common_css/Form_Css.css";
import "./components/common_components/common_css/Common_Css.css";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Contact_Us from "./components/contact_us/Contact_Us";
import Privacy_Policy from "./components/privacy_policy/Privacy_Policy";
import Terms_Conditions from "./components/terms_conditions/Terms_Conditions";
import FAQ from "./components/faq/FAQ";
import Residential from "./components/services/residential/Residential";
import Commercial from "./components/services/commercial/Commercial";
import Interior from "./components/services/interior/Interior";
import Project_Details from "./components/project_details/Project_Details";
import About_Us from "./components/about_us/About_Us";
import All_Projects from "./components/all_projects/All_Projects";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Whatsapp_Lottie from "./components/animation/Whatsapp_Lottie/Whatsapp_Lottie";
import Civil_Renovation from "./components/services/civil_renovation/Civil_Renovation";
import False_Ceiling_Designs from "./components/services/false_ceiling_designs/False_Ceiling_Designs";
import Professional_Painting_Services from "./components/services/professional_painting_services/Professional_Painting_Services";
import Home_Automation from "./components/services/home_automation/Home_Automation";
import Designing_Visualization from "./components/services/designing_visualization/Designing_Visualization";

function App() {
  const phone = "919767297324";

  const handleClick = () => {
    const url = `https://wa.me/${phone}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About_Us />} />
        <Route path="/contact-us" element={<Contact_Us />} />
        <Route path="/privacy-policy" element={<Privacy_Policy />} />
        <Route path="/terms-conditions" element={<Terms_Conditions />} />
        <Route path="/faq" element={<FAQ />} />

        <Route
          path="/services/furniture-custom-carpentry"
          element={<Residential />}
        />
        <Route
          path="/services/modular-kitchens"
          element={<Commercial />}
        />
        <Route
          path="/services/acoustic-theatre-design"
          element={<Interior />}
        />
        <Route
          path="/services/civil-renovation-work"
          element={<Civil_Renovation />}
        />
        <Route
          path="/services/false-ceiling-designs"
          element={<False_Ceiling_Designs />}
        />
        <Route
          path="/services/professional-painting-services"
          element={<Professional_Painting_Services />}
        />

         <Route
          path="/services/home-automation"
          element={<Home_Automation />}
        />

          <Route
          path="/services/3D-designing-visualization"
          element={<Designing_Visualization />}
        />

        <Route path="/project-details/:id" element={<Project_Details />} />
        <Route path="/projects" element={<All_Projects />} />

        {/* <Route
          path="/services/residential-interior-design"
          element={<Residential />}
        />
        <Route
          path="/services/commercial-interior-design"
          element={<Commercial />}
        />
        <Route
          path="/services/interior-design-consultation"
          element={<Interior />}
        />
        <Route
          path="/services/interior-design-consultation"
          element={<Interior />}
        />
        <Route
          path="/services/interior-design-consultation"
          element={<Interior />}
        /> */}
      </Routes>
      <Footer />

      <div className="floating_icon" onClick={handleClick}>
        <Whatsapp_Lottie />
      </div>
    </>
  );
}

export default App;
